module.exports = __webpack_public_path__ + "static/media/Self_management.e3d0b21d.svg";